export default __webpack_public_path__ + "static/media/480_dummy2016-tennisclub01-de.ffe4b49a.png";